module.exports = __webpack_public_path__ + "img/西青果.2e5915d2.jpg";